define('modules/form_editor/views/preview_group_base',['require','exports','module','lib/util','base/collectionview','../behaviours/has_toolbar','../behaviours/has_error_message','../../editor/models/editorstate','ldsh!../templates/preview_group'],function(require, exports, module){
  "use strict";
  var util = require("lib/util"),
      CollectionView = require("base/collectionview"),
      HasToolbar = require("../behaviours/has_toolbar"),
      HasErrorMessage = require("../behaviours/has_error_message"),
      EditorState = require("../../editor/models/editorstate");

  var getAMPStateId = function() {
    var randomId = util.generateRandom() + util.generateRandom();
    return 'ampStateId' + randomId;
  };

  module.exports = CollectionView.extend({
    template: require("ldsh!../templates/preview_group"),
    itemContainer: ".js-items",
    className: "form-group ed-panel-item form-group-col",
    events: {
      "click": "onClick"
    },
    helpers: function() {
      return {
        alignLeft: this.collection.length === 1,
        isAMP: EditorState.getAMPState(),
        ampStateId: this.model.get("ampStateId")
      };
    },
    constructor: function(options){
      options.collection = options.model.items;
      module.exports.__super__.constructor.call(this, options);
    },
    initialize: function(options){
      this.vent = options.parent.vent;
      this.activeItem = options.parent.activeItem;
      this.listenTo(this.model, "item:selected", _.bind(function(selected){
        this.$el.toggleClass("item-is-edited", selected);
      }, this));
      this.listenTo(this.model, "change", function(model){
        this.collection.trigger("sort");
      });
      if (EditorState.getAMPState()) {
        this.model.set('ampStateId', getAMPStateId());
      }
      // this.collection = this.model.items;
    },
    onClick: function(e){
      //this.trigger("item:select", this);
      if(this.activeItem.get("item") !== this.model){
        this.trigger("item:select", this);
      }
      this.$el.blur();
      e.preventDefault();
    },
    onRender: function(){
      this.$el.toggleClass("ed-is-required", this.model.get("isRequired"));
      this.$el.removeClass(this.model.previous("widthClass"));
      this.$el.addClass(this.model.get("widthClass"));
      //why this? because setting a model attribute to the same
      //value doesn't trigger any change event. When reordering
      //we need this to mark the view as selected again
      var meSelected = (this.activeItem.get("item") === this.model);
      this.model.trigger("item:selected", meSelected);
    }
  });

  util.mixin(module.exports, HasToolbar);
  util.mixin(module.exports, HasErrorMessage);
});

